import { T } from "../../theme";
import { REL } from "../../theme";
import { usePeople } from "../../context/PeopleContext";

export function Av({p, size=40}) {
  const c = REL[p.type]?.color || T.partner;
  return (
    <div style={{width:size,height:size,borderRadius:"50%",background:c+"22",border:`2px solid ${c}55`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:size*.28,fontWeight:700,color:c,fontFamily:"'Crimson Pro',serif",flexShrink:0,position:"relative",overflow:"hidden"}}>
      {p.photo ? <img src={p.photo} style={{width:"100%",height:"100%",objectFit:"cover",borderRadius:"50%"}}/> : (p.ini||p.initials)}
    </div>
  );
}

export function Tog({on, set, c}) {
  return (
    <div onClick={()=>set(!on)} style={{width:40,height:22,borderRadius:11,background:on?(c||T.sage):T.edgeMid,position:"relative",cursor:"pointer",transition:"background .2s",flexShrink:0}}>
      <div style={{position:"absolute",top:2,left:on?20:2,width:18,height:18,borderRadius:"50%",background:"white",boxShadow:"0 1px 3px rgba(0,0,0,.18)",transition:"left .2s"}}/>
    </div>
  );
}

export function Tag({label, color}) {
  return (
    <span style={{padding:"2px 8px",borderRadius:20,background:color+"16",border:`1px solid ${color}35`,color,fontSize:11,fontWeight:500}}>{label}</span>
  );
}

export function Card({children, style}) {
  const {compact} = usePeople();
  return (
    <div style={{background:T.surface,borderRadius:compact?10:16,border:`1px solid ${T.edge}`,boxShadow:"0 2px 12px rgba(60,40,20,.05)",overflow:"hidden",marginBottom:compact?8:14,...style}}>{children}</div>
  );
}

export function CardHead({icon, label, sub, variant}) {
  const {compact} = usePeople();
  const isDanger=variant==="danger";
  return (
    <div style={{padding:compact?"8px 14px 6px":"12px 16px 8px",borderBottom:`1px solid ${isDanger?T.red+"35":T.edge}`,background:isDanger?T.red+"14":T.panel}}>
      <div style={{display:"flex",alignItems:"center",gap:8}}>
        <span style={{fontSize:compact?12:14}}>{icon}</span>
        <span style={{fontSize:compact?12:13,fontWeight:700,color:isDanger?T.red:T.bark}}>{label}</span>
      </div>
      {sub && <p style={{fontSize:11,color:isDanger?T.red+"99":T.muted,marginTop:2,paddingLeft:22}}>{sub}</p>}
    </div>
  );
}

export function Row({label, sub, right, border=true}) {
  const {compact} = usePeople();
  return (
    <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",padding:compact?"7px 14px":"11px 16px",gap:12,borderBottom:border?`1px solid ${T.edge}`:"none"}}>
      <div style={{flex:1,minWidth:0}}>
        <p style={{fontSize:compact?12:13,fontWeight:500,color:T.ink}}>{label}</p>
        {sub && <p style={{fontSize:compact?10:11,color:T.muted,marginTop:1,lineHeight:1.4}}>{sub}</p>}
      </div>
      <div style={{flexShrink:0}}>{right}</div>
    </div>
  );
}
